import { Injectable } from '@angular/core';
import { ConfigService } from '@app/finxone-web-frontend/app/lib/services/config-service/config-service.service';
import { FileUploadResponse } from '@finxone-platform/shared/sys-config-types';
import { MatIconRegistry } from '@angular/material/icon';
import {
  iconNameFromFileNameSvg,
  registerProjectIconWithUrl,
} from '../../../../../../../libs/shared/utils/src/icons/register-icons.utils';
import { DomSanitizer } from '@angular/platform-browser';
import { IconCacheService } from '@finxone-platform/shared/services';
import { take } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RegisterProjectIconsService {
  constructor(
    private configService: ConfigService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private iconCacheService: IconCacheService,
  ) {}

  public registerAllProjectIcons() {
    this.configService
      .getAllProjectIcons()
      .pipe(take(1))
      .subscribe((icons: any) => {
        icons.result.forEach((iconFile: FileUploadResponse) => {
          registerProjectIconWithUrl(
            iconFile.path,
            iconNameFromFileNameSvg(iconFile.filename),
            this.matIconRegistry,
            this.domSanitizer,
          );
        });
        const iconsForHandlebars = icons.result.map((iconFile: FileUploadResponse) => {
          return {
            name: 'project:' + iconNameFromFileNameSvg(iconFile.filename),
            url: iconFile.path,
          };
        });
        this.iconCacheService.initializeIconUrls(iconsForHandlebars);
      });
  }
}
